import moment from "moment";
import { isPricingPlan24Enabled, isPricingPlan24V2Enabled, isFreemiumPlanEnabled, isGrowth24PlanEnabled } from "h-commons";

import { getUpdatedPlanDetails, OLD_LITE24_PLANIDS } from "../../utils";
import { ORDERED_FEATURES_LIST } from "../constants/constants";
import { isTieredPricingFeatureEnabled } from "../../../../../common";
/**
 * Returns a filtered list of plans, including the current plan and all higher or lower plans,
 * based on the current plan name and the available plans list.
 *
 * @param {Number} planDisplayName The plan name to be display
 * @param {Array} availableFeatures List of available feature flags
 * @param {Boolean} isForFlattening Set true to get lower plans with current plans or
 * by default higher plans with current plan are returned.
 * @returns A filtered list of plans that need to be displayed
 */
export const getPlansToDisplay = (
    planDisplayName,
    currentPlanId,
    availableFeatures,
    isForFlattening = false,
  ) => {

    const {Free, Lite_23, Pro_23, Elite_23, Lite_24, Lite_24_v2, Pro_24, Elite_24, Growth_24,Lite_tiered_25,Growth_tiered_25,Pro_tiered_25,Elite_tiered_25 } = getUpdatedPlanDetails(availableFeatures);
  
    let plansList = [Lite_23, Pro_23, Elite_23];

    if(isPricingPlan24Enabled(availableFeatures)) { // Check for pricing revamp 24
        plansList = [Lite_24, Pro_24, Elite_24];
        // Only show Lite_24_v2 if not on old lite24 plans and pricing revamp phase 2 is enabled.
        if(isPricingPlan24V2Enabled(availableFeatures) && !OLD_LITE24_PLANIDS.includes(currentPlanId)){
            plansList[0] = Lite_24_v2;
        }
        if(isFreemiumPlanEnabled(availableFeatures)){
            plansList.unshift(Free);
        }
        if(isGrowth24PlanEnabled(availableFeatures)){
            // Append growth plan before pro
            const indexOfPro = plansList.indexOf(Pro_24);
            if(indexOfPro !== -1) plansList.splice(indexOfPro, 0, Growth_24);
        }
    }

    if(isTieredPricingFeatureEnabled(availableFeatures)){ // Check for tiered pricing revamp 25
        plansList = [Lite_tiered_25,Growth_tiered_25,Pro_tiered_25,Elite_tiered_25];
        if(isFreemiumPlanEnabled(availableFeatures)){
            plansList.unshift(Free);
        }
    }

    const currentPlanIndex = plansList.findIndex(
      (plan) => plan?.displayName === planDisplayName
    );
  
    //If isForFlattening get lower plans with current plan or get higher plans with current plan.
    if (currentPlanIndex !== -1) {
      return isForFlattening
        ? plansList.slice(0, currentPlanIndex + 1)
        : plansList.slice(currentPlanIndex);
    }
    return [];
  };
  
// Get number of days for the higher plan trial to end.
export const getDaysLeftUntilTrialEnd = (endDate) => moment(endDate).diff(moment().startOf('day'), 'days');

// Calculate the difference in days between the current date and the end date of the previous trial
export const getDaysElapsedSinceTrialEnd = (endDate) => moment().diff(endDate, 'days');

export const getPlanNameBeforeUnderscore = (planName) => {
    if (!planName) return '';
    return planName.split('_')[0];
}

/**
 * 
 * @param {Array} featureList List of features to be sorted
 * @returns Sorted feature list w.r.t ordering of `ORDERED_FEATURES_LIST`
 */
export const getOrderedFeatureList = (featureList) => {

    const orderMap = new Map();
    ORDERED_FEATURES_LIST.forEach((feature, index) => {
        orderMap.set(feature, index);
    });

    featureList.sort((f1,f2)=>{
        const ind1 = orderMap.get(f1.value);
        const ind2 = orderMap.get(f2.value);

        // If both features are found in the orderArray, compare their indices
        if (ind1 !== undefined && ind2 !== undefined) {
            return ind1 - ind2;
        }

        // If one feature is found but not the other, prioritize the one found
        if (ind1 !== undefined) {
            return -1;
        }
        if (ind2 !== undefined) {
            return 1;
        }

        // If neither feature is found, retain the original order
        return 0;
    });
    return featureList;
}